"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/styles");

var _styles2 = require("@material-ui/core/styles");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLORS = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  GRAY: {
    VARIANT1: '#f0f0f0',
    VARIANT2: '#0000001f',
    VARIANT3: '#8c8c8c',
    VARIANT4: '#b2b2b2',
    VARIANT5: '#aaaaaa'
  },
  GREEN: {
    LIGHTER: '#C9F0D9',
    VARIANT1: '#bedc43'
  },
  PRIMARY: {
    MAIN: '#69D895',
    LIGHT: '#C9F0D9',
    DARK: '#69D895'
  },
  SECONDARY: {
    MAIN: '#636262',
    LIGHT: '#D5D3D3' //'#747474',

  },
  TERTIARY: {
    MAIN: '#22222280',
    PRIMARY: '#E2EDFD'
  },
  BORDER: '#dbdbdb',
  SHADOW: '#22222229',
  BACKGROUND: '#f9f9f9',
  ERROR: '#ff5d25',
  TEXT: {
    PRIMARY: '#636262',
    SECONDARY: '#D5D3D3',
    MAIN: '#636262',
    ICON: '#847B7B'
  },
  DEFAULT: {
    PRIMARY: '#F4F2F2'
  }
};
var theme = (0, _styles2.createTheme)({
  props: {
    MuiSelect: {
      IconComponent: function IconComponent(_ref) {
        var className = _ref.className;
        return className.indexOf('MuiSelect-iconOpen') > -1 ? /*#__PURE__*/_react.default.createElement(_icons.ExpandLess, {
          className: "MuiSelect-icon MuiSelect-iconOutlined"
        }) : /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, {
          className: "MuiSelect-icon MuiSelect-iconOutlined"
        });
      },
      MenuProps: {
        getContentAnchorEl: undefined,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        }
      }
    }
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderRadius: '1.75rem'
      }
    },
    MuiListItem: {
      // using direct colors as theme is not initialized yet at this point
      button: {
        '&:hover': {
          backgroundColor: COLORS.GREEN.LIGHTER
        },
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: COLORS.GREEN.LIGHTER
          },
          backgroundColor: COLORS.PRIMARY.MAIN
        }
      },
      root: {
        whiteSpace: 'break-spaces'
      }
    },
    MuiInputBase: {
      root: {
        fontSize: '0.8125rem'
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: '0.8125rem'
      }
    },
    MuiPopover: {
      paper: {
        borderRadius: '1rem'
      }
    },
    MuiInputAdornment: {
      root: {
        color: COLORS.TEXT.ICON
      }
    },
    MuiButton: {
      contained: {
        backgroundColor: COLORS.DEFAULT.PRIMARY,
        '&:hover': {
          backgroundColor: COLORS.DEFAULT.PRIMARY
        }
      }
    }
  },
  palette: {
    background: {
      default: COLORS.BACKGROUND,
      black: COLORS.BLACK,
      paper: COLORS.WHITE,
      primary: COLORS.PRIMARY.MAIN,
      white: COLORS.WHITE,
      transparent: 'transparent'
    },
    boldSecondary: {
      main: COLORS.GRAY.VARIANT3,
      secondary: COLORS.GRAY.VARIANT4,
      dark: COLORS.GRAY.VARIANT5
    },
    boxShadow: {
      main: COLORS.SHADOW
    },
    icon: {
      main: COLORS.TEXT.ICON
    },
    primary: {
      contrastText: COLORS.WHITE,
      gray: COLORS.TEXT.SECONDARY,
      white: COLORS.WHITE,
      main: COLORS.PRIMARY.MAIN,
      light: COLORS.PRIMARY.LIGHT,
      dark: COLORS.PRIMARY.DARK,
      green: COLORS.GREEN.VARIANT1,
      lightGreen: COLORS.GREEN.LIGHTER
    },
    secondary: {
      border: COLORS.BORDER,
      filled: COLORS.GRAY.VARIANT1,
      main: COLORS.SECONDARY.MAIN,
      light: COLORS.SECONDARY.LIGHT,
      dark: COLORS.TEXT.PRIMARY
    },
    error: {
      main: COLORS.ERROR
    },
    success: {
      main: COLORS.PRIMARY.MAIN
    },
    text: {
      black: COLORS.BLACK,
      error: COLORS.ERROR,
      gray: COLORS.TEXT.SECONDARY,
      main: COLORS.TEXT.MAIN,
      primary: COLORS.TEXT.PRIMARY,
      secondary: COLORS.TEXT.SECONDARY,
      white: COLORS.WHITE
    },
    border: {
      color: COLORS.BORDER
    },
    grey: {
      50: COLORS.GRAY.VARIANT2
    },
    tertiary: {
      main: COLORS.TERTIARY.MAIN,
      primary: COLORS.TERTIARY.PRIMARY
    }
  },
  typography: {
    body1: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: '-0.0125rem',
      lineHeight: '1.125rem'
    },
    subtitle2: {
      fontSize: '14px',
      fontStretch: 'normal',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      lineHeight: 'normal'
    },
    h3: {
      fontSize: '2.125rem'
    },
    h4: {
      fontSize: '1.75rem'
    },
    fontFamily: 'Noto Sans',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal'
  }
});
exports.theme = theme;

var Theme = function Theme(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), children);
};

Theme.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Theme;
exports.default = _default;